"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _AlertComponent = _interopRequireDefault(require("@insided/shared/uikit/AlertComponent"));

var ErrorList = function ErrorList(_ref) {
  var _ref$errors = _ref.errors,
      errors = _ref$errors === void 0 ? [] : _ref$errors;
  if (!errors.length) return null;
  return (0, _preact.h)("div", {
    className: "content-errors"
  }, errors.map(function (error, index) {
    return (0, _preact.h)(_AlertComponent.default, {
      messageType: "error",
      message: 'errorMessage' in error ? error.errorMessage : null,
      key: index
    });
  }));
};

var _default = ErrorList;
exports.default = _default;